import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=2d60776e&scoped=true"
import script from "./ExternalLink.vue?vue&type=script&lang=js"
export * from "./ExternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60776e",
  null
  
)

export default component.exports